export default {
    reboot_device_title: "Reboot Device",
    reboot_device_reboot_command_has_been_sent: "Reboot command has been sent",
    reboot_device_error_sending_the_command: "Error sending the command",
    reboot_device_sending_command_not_accepted: "The command could not be sent to device, please check the device status",
    reboot_device_label: "Do you want to reboot the device?",
    reboot_device_reboot: "Reboot",
    reboot_device_message_success: "The request to Reboot the devices has been received. Click here to view the status of the change.",
    reboot_device_bulk_reboot: "Bulk Reboot",
}